export const SESSION_ONBOARDING_KEY = 'OD';
